import request from '@/services/base/request';
import ServicesEnum from '@/services/_helpers/_types';
export default {
    getInnerTransfersHistory: ({ query }) => request(ServicesEnum.traderProfileV2, `/exchanges/binance/withdraw/history/inner-transfer/${query}`, 'get', null),
    getOuterTransfersHistory: ({ query }) => request(ServicesEnum.traderProfileV2, `/exchanges/binance/withdraw/history/withdraw-transfer/${query}`, 'get', null)
};
